import type { CartUpdateAction } from "@commercetools/platform-sdk"
import { JOGGResponse } from "@jog/types"

import { handleCartError, typedBoolean } from "../helper"
import { JoggApiOption } from "./client"

export const cleanCostBase =
    ({ execute }: Pick<JoggApiOption, "execute">) =>
    async (
        cartId: string,
        version: number,
        actions?: CartUpdateAction[],
        paymentCostId?: string
    ): Promise<JOGGResponse<void>> =>
        handleCartError(
            (version) =>
                execute({
                    uri: `/ctp/carts/${cartId}`,
                    method: "POST",
                    body: {
                        version,
                        actions: [
                            ...(actions || []),
                            paymentCostId ? { action: "removeCustomLineItem", customLineItemId: paymentCostId } : null,
                            { action: "recalculate", updateProductData: true },
                        ].filter(typedBoolean),
                    },
                }),
            version
        )
